import { GeneralResponse } from "../../../types/api";
import { UseMutationResult, useMutation } from "@tanstack/react-query";
import { Methods } from "../../constants/CommonConstants";
import Api from "../axios";
import { EndPoints } from "../endPoints";
import { getTranslation } from "../../Functions";
import { IForgetPasswordSendCodeRequest } from "../../../types/apis/general";

export const ForgetPasswordSendCode = async (
  payload: IForgetPasswordSendCodeRequest,
): Promise<GeneralResponse> => {
  const response = await Api<
    any,
    GeneralResponse<IForgetPasswordSendCodeRequest>
  >({
    method: Methods.POST,
    endpoint: EndPoints.forgetPasswordSendCode,
    body: payload,
  });
  if (response.Code === -1) {
    throw new Error(getTranslation("phone_validation_error"));
  } else if (!response.Status) {
    throw new Error(JSON.stringify(response.ErrorMessage));
  }
  return response;
};

export const useForgetPasswordSendCode = (options = {}) => {
  const mutation: UseMutationResult<
    GeneralResponse,
    Error,
    IForgetPasswordSendCodeRequest
  > = useMutation({
    mutationFn: ForgetPasswordSendCode,
    ...options,
  });

  return {
    data: mutation.data,
    error: mutation.error,
    isError: mutation.isError,
    isSuccess: mutation.isSuccess,
    mutate: mutation.mutate,
    reset: mutation.reset,
    status: mutation.status,
  };
};
